import { Box } from '@jfs/ui-new'
import { useRef, useState } from 'react'
import { FlatList } from 'react-native'
import { ExpandableComponent } from './ExpandableComponent'

interface AccordionListInterface {
  data: any
  multiSelect?: boolean
  renderHeader: any
  renderData: any
  childListFooter?: any
  theme: any
}

export const AccordionList = ({
  data,
  multiSelect = false,
  renderHeader,
  renderData,
  childListFooter,
  theme,
}: AccordionListInterface) => {
  const [listDataSource, setListDataSource] = useState(data)
  const [selectedIndex, updateSelectedIndex] = useState(-1)

  const updateLayout = (index: number) => {
    const array = [...listDataSource]
    if (multiSelect) {
      array[index].isExpanded = !array[index].isExpanded
    } else {
      array.forEach((_, placeindex) =>
        placeindex === index
          ? (array[placeindex].isExpanded = !array[placeindex].isExpanded)
          : (array[placeindex].isExpanded = false),
      )
    }
    setListDataSource(array)
  }

  if (selectedIndex === -1) {
    const array = [...listDataSource]
    if (multiSelect) {
      array[0].isExpanded = !array[0].isExpanded
    } else {
      array.forEach((_, placeindex) =>
        placeindex === 0
          ? (array[placeindex].isExpanded = !array[placeindex].isExpanded)
          : (array[placeindex].isExpanded = false),
      )
    }
    updateSelectedIndex(0)
    setListDataSource(array)
  }

  console.log('selectedIndex', selectedIndex)

  const _renderParentList = ({ item, index }: any) => {
    return (
      <ExpandableComponent
        index={index}
        renderHeader={renderHeader}
        renderData={renderData}
        onHeaderClick={(index: number) => {
          updateSelectedIndex(index)
          updateLayout(index)
        }}
        childListFooter={childListFooter}
        item={item}
        theme={theme}
      />
    )
  }
  const flatListRef = useRef(null)
  return (
    <Box overflow={'scroll'} f={1}>
      <FlatList ref={flatListRef} data={listDataSource} renderItem={_renderParentList} />
    </Box>
  )
}
